<div class="flex flex-col space-y-8">
    <form [formGroup]="paymentDetailsForm">
        <div class="flex gap-5">
            <div class="flex-1 min-w-0">
                <app-order-summary-header
                    [orderSummaryData]="paymentDetailsSummaryData"
                    [cityStateZip]="cityStateZip"
                ></app-order-summary-header>
            </div>
            <div
                class="w-4/12 lg:w-3/12 2xl:w-2/12 flex-shrink-0 flex flex-col justify-between"
            >
                <div class="flex flex-col gap-2">
                    <div
                        class="rounded-lg bg-primary-100 px-6 py-5 flex flex-col gap-2"
                    >
                        <span class="text-base font-medium">Order Total:</span>
                        <span class="text-3xl font-medium">{{
                            paymentDetailsSummaryData.orderTotal
                        }}</span>
                    </div>
                    <div
                        class="rounded-lg px-6 py-5 flex flex-col gap-2"
                        [ngClass]="
                            hasRemainingOutstandingBalance()
                                ? 'bg-error-200'
                                : 'bg-success-200'
                        "
                    >
                        <span class="text-base font-medium"
                            >Outstanding Balance:</span
                        >
                        <span class="text-3xl font-medium">{{
                            getFormattedOutstandingBalance()
                        }}</span>
                    </div>
                </div>
                <mat-form-field
                    appearance="outline"
                    class="w-full"
                    subscriptSizing="dynamic"
                >
                    <mat-label>Status</mat-label>
                    <mat-select
                        [formControl]="paymentDetailsForm.controls.status"
                        panelWidth="w-full"
                    >
                        @for (
                            orderStatus of orderStatusDropdownOptions;
                            track orderStatus.value
                        ) {
                            <mat-option
                                [value]="orderStatus.value"
                                [disabled]="orderStatus.disabled"
                            >
                                {{ orderStatus.label }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field
                    appearance="outline"
                    class="w-full"
                    subscriptSizing="dynamic"
                >
                    <mat-label>PO Number</mat-label>
                    <input
                        matInput
                        [formControl]="poNumber"
                        placeholder="Enter PO Number"
                        maxlength="{{ orderConstants.MAX_PO_NUMBER_LENGTH }}"
                        [appRegexInput]="
                            regexPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                    />
                </mat-form-field>
            </div>
        </div>
    </form>

    @if (paymentTransactionForm) {
        <form
            [formGroup]="paymentTransactionForm"
            class="flex flex-col space-y-8"
        >
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title
                        class="!text-tertiary-900 font-normal text-xl py-2"
                    >
                        <h1
                            class="!text-tertiary-900 font-normal !text-xl !m-0"
                        >
                            Billing Notes (Internal Use Only)
                        </h1>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                @if (paymentDetailsSummaryData.billingNotes) {
                    <p class="text-sm whitespace-pre-wrap">
                        {{ paymentDetailsSummaryData.billingNotes }}
                    </p>
                }
            </mat-expansion-panel>

            <div class="flex flex-col space-y-2">
                @if (!isBillingInformationComplete) {
                    <div
                        class="flex items-center gap-3 rounded-lg border-2 border-warn-500 bg-warn-100 px-4 py-3 text-warn-800 w-full lg:w-3/4 2xl:w-1/2"
                    >
                        <mat-icon aria-hidden="true">warning</mat-icon>
                        <span class="font-medium"
                            >You must add a billing address to the order before
                            a credit card payment can be applied.</span
                        >
                    </div>
                }

                <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title
                            class="!text-tertiary-900 font-normal text-xl py-2"
                        >
                            <h1
                                class="!text-tertiary-900 font-normal !text-xl !m-0"
                            >
                                Add Payment
                            </h1>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="flex flex-col space-y-6 pt-2">
                        <div
                            class="flex items-center gap-6 w-10/12 lg:w-8/12 xl:w-6/12 2xl:w-4/12"
                        >
                            <span class="text-sm text-gray-700 font-medium"
                                >Pay With:</span
                            >
                            <div class="flex items-center gap-4 flex-1">
                                <mat-radio-group
                                    class="flex items-center gap-4"
                                    [formControl]="
                                        paymentTransactionForm.controls
                                            .paymentMethod
                                    "
                                    subscriptSizing="dynamic"
                                    color="primary"
                                >
                                    <mat-radio-button
                                        [value]="paymentMethod.AuthNetAim"
                                        class="text-sm"
                                    >
                                        Credit Card
                                    </mat-radio-button>

                                    @if (isApprovedForInvoiceNet30()) {
                                        <mat-radio-button
                                            [value]="paymentMethod.InvoiceNet30"
                                            class="text-sm"
                                        >
                                            Invoice Net 30 (For Approved
                                            Accounts)
                                        </mat-radio-button>
                                    }
                                </mat-radio-group>
                                @if (!isApprovedForInvoiceNet30()) {
                                    <span
                                        class="inline-flex items-center gap-1.5 ml-auto pl-8 shrink-0"
                                    >
                                        <a
                                            [href]="
                                                externalLinks.enterpriseWireless
                                                    .creditApplication
                                            "
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            class="text-sm font-bold text-primary-600 hover:text-primary-700 hover:underline"
                                        >
                                            EWA Credit Application
                                        </a>
                                        <app-hover-tooltip
                                            [moreInfo]="true"
                                            [message]="
                                                orderPaymentConstants.INVOICE_NET_30_CREDIT_APPLICATION_TOOLTIP
                                            "
                                        ></app-hover-tooltip>
                                    </span>
                                }
                            </div>
                        </div>

                        @if (
                            isAuthNetAim(
                                paymentTransactionForm.controls.paymentMethod
                                    .value
                            )
                        ) {
                            <div
                                class="flex flex-col lg:flex-row items-start gap-3 w-full"
                            >
                                <mat-form-field
                                    appearance="outline"
                                    class="w-10/12 lg:w-8/12 xl:w-6/12 2xl:w-4/12"
                                    subscriptSizing="dynamic"
                                >
                                    <mat-label>Credit Card</mat-label>
                                    <mat-select
                                        [formControl]="
                                            paymentTransactionForm.controls
                                                .cardOnFileId
                                        "
                                        panelWidth="w-full"
                                        subscriptSizing="dynamic"
                                        placeholder="Please select or add a credit card"
                                    >
                                        @for (
                                            cardOption of cardsOnFileDropdownOptions;
                                            track cardOption.value
                                        ) {
                                            <mat-option
                                                [value]="cardOption.value"
                                                [disabled]="cardOption.disabled"
                                            >
                                                {{ cardOption.label }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                    @if (getCardSelectionError(); as error) {
                                        <mat-error>{{ error }}</mat-error>
                                    }
                                </mat-form-field>

                                <div class="flex items-center gap-3 mt-[5px]">
                                    <app-card-type-icon
                                        [cardType]="
                                            selectedCardOnFile?.cardType
                                        "
                                    />

                                    <button
                                        mat-button
                                        mat-raised-button
                                        type="button"
                                        name="edit-card"
                                        color="primary"
                                        class="!rounded-lg"
                                        (click)="editSelectedCreditCard()"
                                        [disabled]="
                                            !paymentTransactionForm.controls
                                                .cardOnFileId.value
                                        "
                                    >
                                        Edit Card
                                    </button>

                                    <button
                                        mat-button
                                        mat-raised-button
                                        type="button"
                                        name="add-new-card"
                                        color="primary"
                                        class="!rounded-lg"
                                        (click)="addNewCreditCard()"
                                    >
                                        Add New Card
                                    </button>
                                </div>
                            </div>
                        }

                        <div class="max-w-[160px]">
                            <mat-form-field
                                appearance="outline"
                                subscriptSizing="dynamic"
                                class="w-full"
                            >
                                <mat-label>Amount</mat-label>
                                <input
                                    matInput
                                    [formControl]="
                                        paymentTransactionForm.controls.amount
                                    "
                                    placeholder="Enter Amount"
                                    [imask]="paymentTransactionAmountMaskConfig"
                                    [unmask]="'typed'"
                                />
                                @if (getAmountMaxError(); as error) {
                                    <mat-error>{{ error }}</mat-error>
                                }
                            </mat-form-field>
                        </div>

                        @if (
                            isInvoiceNet30(
                                paymentTransactionForm.controls.paymentMethod
                                    .value
                            )
                        ) {
                            <div class="w-1/2">
                                <mat-checkbox
                                    color="primary"
                                    [formControl]="
                                        paymentTransactionForm.controls
                                            .sendInvoiceUponSave
                                    "
                                >
                                    Send Invoice Upon Save
                                </mat-checkbox>
                            </div>
                        }

                        @if (paymentTransactionForm?.enabled) {
                            <div class="flex items-center gap-3 pb-2">
                                <button
                                    mat-stroked-button
                                    type="button"
                                    color="primary"
                                    class="!border-primary-700"
                                    (click)="resetPaymentTransactionForm()"
                                >
                                    Clear
                                </button>
                                <button
                                    mat-raised-button
                                    type="button"
                                    name="save"
                                    color="primary"
                                    cdkFocusInitial
                                    [disabled]="paymentTransactionForm?.invalid"
                                    (click)="applyPaymentTransaction()"
                                >
                                    Apply Payment
                                </button>
                            </div>
                        }
                    </div>
                </mat-expansion-panel>
            </div>

            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title
                        class="!text-tertiary-900 font-normal text-xl py-2"
                    >
                        <h1
                            class="!text-tertiary-900 font-normal !text-xl !m-0"
                        >
                            Payment History
                        </h1>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <ag-grid-angular
                    [context]="paymentHistoryGridContext"
                    [rowData]="paymentHistoryGridRowData"
                    [gridOptions]="paymentHistoryGridOptions"
                    (gridReady)="onPaymentHistoryGridReady($event)"
                    class="ag-theme-quartz w-full"
                ></ag-grid-angular>
            </mat-expansion-panel>
        </form>
    }
</div>
